module.exports = __webpack_public_path__ + "static/media/test16_1.7ebcb562.png";